import { render } from "./DemoContentTable.vue?vue&type=template&id=57f5ab0c"
import script from "./DemoContentTable.vue?vue&type=script&lang=js"
export * from "./DemoContentTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__